import SignUpCard from "@/common/SignUpCard";
import HomeLayout from "@/layouts/home.layout";
import { signinCardConfigs } from "@/utils/constant/landingPage.constant";
import { useNavigate } from "react-router-dom";

const LoginHome = () => {
  const navigate = useNavigate();

  return (
    <HomeLayout>
      <div className=" flex items-center justify-center flex-col py-12 gap-4">
        <h1 className="text-xl md:text-3xl font-semibold mt-5 md:mt-2 leading-normal">Get started with Lystproof!</h1>
        <span className="text-sm md:text-base"> Choose your account type and begin your journey.</span>
      </div>
      <div className="flex flex-wrap justify-center gap-12 gap-y-16 py-10 pb-12 max-w-5xl mx-auto px-3">
        {signinCardConfigs.map((card) => (
          <SignUpCard
            key={card?.id}
            {...card}
            onCLickHandler={() => navigate(`/login/${card.userTypekey}`)}
            bottomContent={{ text: "New to Lystproof?", link: { text: "Sign up", value: `/sign-up/${card.userTypekey}` } }}
          />
        ))}
      </div>
    </HomeLayout>
  );
};

export default LoginHome;
